// API base URL
export const API_URL = process.env.REACT_APP_API_URL || 'http://localhost:5000/api';

// Other API configurations can be added here
export const API_TIMEOUT = 30000; // 30 seconds 